export const CanvasFlipType = {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL:'VERTICAL'
};

export const BookFlipType = {
    LEFT_TO_RIGHT: 'R',
    RIGHT_TO_LEFT: 'L'
};
